import { defaultPageSelectors, IDefaultPageLayoutProps } from '@opengov/app-core/layout';
import { selectNavigationBarProps } from '@opengov/app-core/navigation/selectors';
import { selectToast, viewActionCreators } from '@opengov/component-library-classic/module/view';
import { selectIsModalOpen, selectIsToastOpen } from '@opengov/component-library-classic/module/view/selectors';
import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';
import { selectFeatureFlag } from '@opengov/feature-flag/launchDarkly';
import { ReportingConfig } from '@opengov/app-config-reporting';

import { getModalSelector } from '../../../../application/common/modals';

export const aOrB = <T>(a: T, b: T): T => a || b;

export const selectReportPageProps = createStructuredSelector<any, IDefaultPageLayoutProps<any, any>>({
  ...defaultPageSelectors,
  shouldShowModal: createSelector(selectIsModalOpen, defaultPageSelectors.shouldShowModal, aOrB),
  isToastOpen: createSelector(selectIsToastOpen, defaultPageSelectors.isToastOpen, aOrB),
  toast: createSelector(selectToast, defaultPageSelectors.toast, aOrB),
  hideToast: () => () => {
    defaultPageSelectors.hideToast();
    viewActionCreators.hideToast();
  },
  modalMetaData: getModalSelector,
  viewElementsOnClick: () => () => {
    //callback is intentionally left empty.
  },
  navigationBarProps: createSelector(selectNavigationBarProps, selectFeatureFlag, (props, getFeatureFlag) => {
    return {
      ...props,
      showAppSwitcher: getFeatureFlag('product-reporting-feature-app-switcher') || false,
      onLogout: () => (window.location.href = '/access/logout')
    };
  }),
  chatbotConfig: () => ({
    integrationKey: ReportingConfig.SF_INTEGRATION_KEY,
    platformName: ReportingConfig.SF_PLATFORM_NAME,
    messageId: ReportingConfig.SF_MESSAGE_ID,
    secretUrl: ReportingConfig.SF_SECRET_URL
  })
});
